var MediaDetailPopupController = require("app/MediaDetailPopup/PopupController"),
    Noop                       = require("app/core/middleware/Noop"),
    ArtistPageController       = require("app/ArtistPage/PageController"),
    RequireLoggedInUser        = require("app/core/middleware/RequireLoggedInUser"),
    ResolveLanguage            = require("app/core/middleware/ResolveLanguage"),
    RouteHandler               = require("app/core/RouteHandler"),
    config                     = require("app/config"),
    get                        = require("object-path").get,
    kind                       = require("enyo/kind"),
    quickMacroize              = require("enyo/macroize").quickMacroize;

module.exports = [{

    /**
     * Artist by Slug
     *
     * @type {RegExp}
     */
    pattern: /^\/([a-z]{2})\/(?:artist|artist-page)\/([0-9a-zA-Z\-]+)$/,

    /**
     * @type {app.core.RouteHandler}
     */
    Handler: kind({

        /**
         * @private
         */
        kind: RouteHandler,

        /**
         * @private
         */
        middleware: [
            ResolveLanguage,
            get(config, "login.enabled", false)
                && get(config, "login.required", false)
                ? RequireLoggedInUser
                : Noop
        ],

        /**
         * Handler for the route
         *
         * @param  {app.core.App}  app         The application core
         * @param  {string}        pathname    The matched pathname
         * @param  {Object}        params      The parameters extracted from the
         *                                     pathname
         * @param  {string}        search      The current search string
         * @param  {boolean}       skipCache   The cached data should be ignored
         * @public
         */
        execute: function(app, pathname, params, search, skipCache) {
            var $mediaPlayerManager = app.$.mediaPlayerManager,
                language            = app.$.i18nService.get("language");

            params = {
                artistSlug: params[1]
            };

            app.$.header.set("showBackButton", true);

            app.activatePage(ArtistPageController, {
                language:   language,
                artistSlug: params.artistSlug,
                tabSlug:    null,
                skipCache:  skipCache
            }, true);

            app.$.analyticsService.sendPageView({
                language:  language,
                mediaItem: quickMacroize("artist/{$artistSlug}", {
                    artistSlug: params.artistSlug
                })
            });

            app.deactivateMediaDetails();

            app.$.state.get("mediaPlayerReady") === 1
                ? $mediaPlayerManager.setMediaPlayerDisplayMode("minimized")
                : $mediaPlayerManager.deactivateMediaPlayer();

            this.finish();
        }
    })
}, {

    /**
     * Artist by Slug + Media Detail Popup by Media Type and Slug
     *
     * @type {RegExp}
     */
    pattern: /^\/([a-z]{2})\/(?:artist|artist-page)\/([0-9a-zA-Z\-]+)\/(album-track|audio|book|episode|issue|podcast-episode|video)\/([0-9a-zA-Z\-]+)$/,

    /**
     * @type {app.core.RouteHandler}
     */
    Handler: kind({

        /**
         * @private
         */
        kind: RouteHandler,

        /**
         * @private
         */
        middleware: [
            ResolveLanguage,
            get(config, "login.enabled", false)
                && get(config, "login.required", false)
                ? RequireLoggedInUser
                : Noop
        ],

        /**
         * Handler for the route
         *
         * @param  {app.core.App}  app         The application core
         * @param  {string}        pathname    The matched pathname
         * @param  {Object}        params      The parameters extracted from the
         *                                     pathname
         * @param  {string}        search      The current search string
         * @param  {boolean}       skipCache   The cached data should be ignored
         * @public
         */
        execute: function(app, pathname, params, search, skipCache) {
            var $mediaPlayerManager = app.$.mediaPlayerManager,
                language            = app.$.i18nService.get("language");

            params = {
                artistSlug:       params[1],
                detailsMediaType: params[2].replaceAll("-", "_"),
                detailsMediaSlug: params[3]
            };

            app.$.header.set("showBackButton", true);

            app.activatePage(ArtistPageController, {
                language:   language,
                artistSlug: params.artistSlug,
                skipCache:  skipCache
            }, false);

            app.activateMediaDetails(MediaDetailPopupController, {
                language:  language,
                mediaType: params.detailsMediaType,
                mediaSlug: params.detailsMediaSlug,
                skipCache: skipCache
            }, true);

            app.$.analyticsService.sendPageView({
                language:  language,
                mediaItem: quickMacroize("{$mediaType}/{$mediaSlug}", {
                    mediaType: params.detailsMediaType.replaceAll("_", "-"),
                    mediaSlug: params.detailsMediaSlug
                }),
                context: quickMacroize("/{$language}/artist-page/{$artistSlug}", {
                    language:   language,
                    artistSlug: params.artistSlug
                })
            });

            app.$.state.get("mediaPlayerReady") === 1
                ? $mediaPlayerManager.setMediaPlayerDisplayMode("minimized")
                : $mediaPlayerManager.deactivateMediaPlayer();

            this.finish();
        }
    })
}, {

    /**
     * Artist by Slug + Playlist by Slug + Audio by Media Type and Slug
     *
     * @type {RegExp}
     */
    pattern: /^\/([a-z]{2})\/(?:artist|artist-page)\/([0-9a-zA-Z\-]+)\/(?:playlist)\/([0-9a-zA-Z\-]+)\/listen\/(album-track|audio|podcast-episode)\/([0-9a-zA-Z\-]+)$/,

    /**
     * @type {app.core.RouteHandler}
     */
    Handler: kind({

        /**
         * @private
         */
        kind: RouteHandler,

        /**
         * @private
         */
        middleware: [
            ResolveLanguage,
            get(config, "login.enabled", false)
                && get(config, "login.required", false)
                ? RequireLoggedInUser
                : Noop
        ],

        /**
         * Handler for the route
         *
         * @param  {app.core.App}  app         The application core
         * @param  {string}        pathname    The matched pathname
         * @param  {Object}        params      The parameters extracted from the
         *                                     pathname
         * @param  {string}        search      The current search string
         * @param  {boolean}       skipCache   The cached data should be ignored
         * @public
         */
        execute: function(app, pathname, params, search, skipCache) {
            var $mediaPlayerManager = app.$.mediaPlayerManager,
                language            = app.$.i18nService.get("language"),
                cursor              = search.get("cursor");

            params = {
                artistSlug:       params[1],
                playlistSlug:     params[2],
                playlistItemType: params[3].replaceAll("-", "_"),
                playlistItemSlug: params[4],
                autoplay:         true,
                cursor:           cursor
            };

            app.$.header.set("showBackButton", true);

            app.activatePage(ArtistPageController, {
                language:         language,
                artistSlug:       params.artistSlug,
                playlistSlug:     params.playlistSlug,
                playlistItemType: params.playlistItemType,
                playlistItemSlug: params.playlistItemSlug,
                autoplay:         params.autoplay,
                skipCache:        skipCache
            }, false);

            app.deactivateMediaDetails();

            $mediaPlayerManager.setMediaPlayerDisplayMode("footer");

            // Have the player load the current item and autoplay.
            $mediaPlayerManager.activateMediaPlayer({
                mediaType:    params.playlistItemType,
                mediaSlug:    params.playlistItemSlug,
                artistSlug:   params.artistSlug,
                playlistSlug: params.playlistSlug,
                autoplay:     params.autoplay,
                cursor:       params.cursor,
                skipCache:    skipCache
            }, true);

            app.$.analyticsService.sendPageView({
                language:  language,
                mediaItem: quickMacroize("{$mediaType}/{$mediaSlug}", {
                    mediaType: params.playlistItemType.replaceAll("_", "-"),
                    mediaSlug: params.playlistItemSlug
                }),
                context: quickMacroize("/{$language}/artist-page/{$artistSlug}/playlist/{$playlistSlug}", {
                    language:     language,
                    artistSlug:   params.artistSlug,
                    playlistSlug: params.playlistSlug
                })
            });

            this.finish();
        }
    })
}];
